import {useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {getHolidays,addHoliday, updateHoliday, getStateLsit} from './HolidayRepo'
import { toast } from "react-toastify";
import { showToast } from "../../../../utils/toastUtils";

interface body{
    HolidayName:string,
    HolidayDate:any,
    Istateid:number,
}

  
interface Holiday {
    enable: boolean,
    params?: {
        id?: number| null,
        search?: string,
        page?: number,
        limit?: number,
        state?:number | null
    }
}

export const useGetHolidays = ({enable = false,params}:Holiday)=>{
return useQuery({
    queryKey:["GET_HLIDAY_LIST",params],
    queryFn:()=>getHolidays(params),
    enabled :enable,  
    retry:false      
})
}

export const useGetStateList =({enable = false}:{enable:boolean})=>{
   return useQuery({
    queryKey:['Get_State_List'],
    queryFn:getStateLsit,
    enabled:enable,
    retry : false
   })
}

//new code  start
export const useUpdateHoliday=()=>{
     const queryClient = useQueryClient();
     return  useMutation({
        mutationFn:({id,Reqbody}:{id:number,Reqbody:any})=>updateHoliday({id,Reqbody}),

        onSuccess:()=>{

            showToast.success("Holiday Updated successfully!")
              queryClient.invalidateQueries({queryKey:['GET_HLIDAY_LIST']});
        },
        onError:(error:any)=>{ 
             console.log('Failes to update Holiday',error.message);
             showToast.error('Failes to update Holiday')
        }
     })
}

//  new Code end's

export const useAddHoliday =()=>{
   const queryClient = useQueryClient();
   return useMutation({
    mutationFn:(reqBody:body)=>addHoliday(reqBody),
    
    onSuccess:()=>{
        showToast.success("Holiday added successfully!")
        queryClient.invalidateQueries({queryKey:["GET_HLIDAY_LIST"]});
    },
    onError:(error:any)=>{
    showToast.error("Failed to add holiday:")
    }
      
   })
} 
 